import { faBriefcase } from "@fortawesome/pro-regular-svg-icons";

import { Button } from "src/design-system/Button";
import { useCurrentUserId } from "src/store/AuthStore";

type ClaimCaseButtonProps = {
  onClick: (userId: string) => void;
  disabled?: boolean;
  loading?: boolean;
};

export const ClaimCaseButton: React.FC<ClaimCaseButtonProps> = ({
  onClick,
  disabled,
  loading = false,
}) => {
  const currentUserId = useCurrentUserId();

  if (!currentUserId) return null;

  return (
    <Button
      isDisabled={disabled || loading}
      iconLeft={faBriefcase}
      isLoading={loading}
      size="sm"
      variant="secondary"
      onClick={() => onClick(currentUserId)}
    >
      Claim case
    </Button>
  );
};
